export const devData = {
  account: {
    version: 100,
    userId: 5006032,
    userName: '李颖1(liying2)',
    isMain: '1',
    status: '0',
    fromSys: 'TPS',
    auditFlag: '0',
    gender: '1',
    nameCn: '李颖1',
    nameEn: 'liying2222',
    jobTitleCn: '前端开发工程师',
    jobTitleEn: 'dev123',
    headPortrait:
      'https://resources.jctrans.com/res/account/pc/img/default_avator.png',
    whatsapp: '333ssssss',
    account: 'liying1',
    mobile: '3e38LqtA7PlnAo8TIMqWKA==',
    mobileValidFlag: '1',
    areaCode: '+86',
    countryId: 1,
    email: 'W1RbJOYlksfSIcOabXHoCEUvJiGyeCimLq97EsxdkBg=',
    emailValidFlag: '1',
    createTime: '2022-06-29T11:54:08',
    jcpayFlag: '1',
  },
  company: {
    version: 125,
    compId: 5006000,
    compName: 'sadadfwfawf(jctrans-en-company)',
    verificated: '1',
    status: '0',
    violationStatus: '0',
    auditFlag: '0',
    fromSys: 'TPS',
    transactionStatus: '2',
    memberCode: '123',
    nameCn: 'sadadfwfawf',
    nameEn: 'jctrans-en-company',
    countryId: 1,
    cityId: 2667,
    countryNameCn: '中国',
    countryNameEn: 'China',
    cityNameCn: '唐山',
    cityNameEn: 'Tangshan',
    scale: 'large',
    estabYears: '2023-12-11',
    registeredAddressCn: '发发发',
    registeredAddressEn: 'asdasd',
    officeAddressCn: 'qq',
    officeAddressEn: 'qq',
    industrySector: 'Logistics',
    tel: '13124272234',
    logoFile:
      'https://wlw-obs-dev-bj4n.obs.cn-north-4.myhuaweicloud.com:443/COMPANY_LOGO%2Fbc41eace-7faf-4c06-ada8-40a1c9b94129',
    twitter: '123456',
    youtube: '00923',
    facebook: 'facebook',
    linkedIn: 'linked',
    compVips: [
      {
        name: 'JC Premium',
        code: 'GCP',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 1,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/2f3de9c8-0c3d-474e-8e7d-7971591ece60.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/99beb61e-69f3-485d-bbee-4293e9e3ed4a.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/e2151735-84cf-48db-8c31-e6db8dd5cc21.png',
      },
      {
        name: 'JC eCommerce',
        code: 'JC eCommerce',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 1,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/5584c2e7-d16f-4659-a110-aa9cf16b59f1.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b978665d-91e7-4642-bfa4-0ba6176b103d.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/dff5031b-44ce-40b5-bb28-cc0921ab8ade.png',
      },
      {
        name: 'JC Railway',
        code: 'JC Railway',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 1,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/fc8e5efd-b7b2-4622-848d-1a7b59b6a77b.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/dc381aaf-5eb5-4713-b462-2a3d9324cccf.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/00496e17-4040-4593-b113-452650720c7c.png',
      },
      {
        name: 'JC Vendor Transportation',
        code: 'JC Vendor Transportation',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 1,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/8901c0eb-5a22-4f7c-a4f8-0df9f9ba5fc1.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/97d626e6-ad71-4f5c-a55c-2005d6aaab14.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/5cfe9f2e-2030-4e3d-b70d-ec7bb643b143.png',
      },
      {
        name: 'JC Vendor Warehousing',
        code: 'JC Vendor Warehousing',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 1,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/87865115-7e46-4be4-944b-242e8b5dcdc3.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/8ff60065-f003-49f8-b1b4-bcbf8f3282ea.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/e8b1e7bf-4dff-46ce-be6b-2d18d69a722a.png',
      },
      {
        name: 'TSP',
        code: 'TSP',
        start: '2024-12-13',
        expireAt: '2025-12-12',
        yearsAddUp: 2,
        vipType: '4',
        vipCertificateWeb:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/4558fdc4-b663-4d2f-8eb2-b24cddffb92e.png',
        vipCertificatePrint:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/ff70a31b-9e88-4685-a98c-276f535b8bd2.png',
        vipLogoFile:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
        vipCertificateLogo:
          'https://assets-dev.jctrans.com/COMMON_IMG_GEN/d166e42a-132d-4172-aadd-8cb8dd14161c.png',
      },
    ],

    compTags: [],
    regCapital: '554',
    registeredNumber: 'adasd',
    historyVips: ['GCP'],
    jcpayFlag: '1',
    perms: {
      MPERA:
        '{"compId":5006000,"shopStatus":"0","settleStatus":"3","auditFlag":"0","trxFlag":"1","shopImproveStatus":"0","aiRightStatus":"0"}',
    },
  },
}
